import React, { useContext, useState,useEffect } from "react";
import { TextField } from "@mui/material";
import TransferContext, {
  TransferProvider,
} from "../TranferContextProvider.js";
import { sendOtp } from "../quickTransferServices/QuickTransferServices.js";
import { notifySuccess, notifyWarning } from "../../../util/Notification.js";
import CircularProgress from "@mui/material/CircularProgress";
import Backdrop from "@mui/material/Backdrop";
import { getCustomerNameById } from "../quickTransferServices/QuickTransferServices.js";
import CryptoJS from "crypto-js";

const EnterCitizenId = () => {
  const {
    activeStep,
    setActiveStep,
    skipped,
    setSkipped,
    citizenId,
    setCitizenId,
    mobileTel,
    setMobileTel,
    customerName,
    setCustomerName
  } = useContext(TransferContext);

  const [loading, setLoading] = useState(false);

  const encryptCitizenId = (citizenId) => {
    const encrypted = CryptoJS.AES.encrypt(
      citizenId,
      process.env.REACT_APP_ENCRYPT_DATA
    ).toString();
    return encrypted;
  };

  const getName = async () => {
    if (citizenId) {
      const customerRes = await getCustomerNameById(citizenId);
      if (customerRes.status && customerRes.name) {
        setCustomerName(customerRes.name);
        console.log("Customer Name:", customerRes.name);
      }
    }
  };

  const verifyOtp = async () => {
    if (citizenId == "") {
      notifyWarning("กรุณาระบุเลขประจำตัวประชาชน หรือ เลขที่หนังสือเดินทาง");
    } else {
      setLoading(true);

      // Encrypt and store citizenId in localStorage
      const encryptedCitizenId = encryptCitizenId(citizenId);
      localStorage.setItem("customer_id", encryptedCitizenId);

      // Get customer name first
      await getName();

      const res = await sendOtp(citizenId);

      if (res.success == false) {
        notifyWarning(res.payload.error);
        setLoading(false);
      } else {
        setMobileTel(res.payload.profile)
        notifySuccess("ส่งรหัส OTP สำเร็จ");
        handleNext();
        setTimeout(() => {
          setLoading(false);
        }, 1000);
      }
    }
  };

  const handleNext = () => {
    let newSkipped = skipped;
    if (isStepSkipped(activeStep)) {
      newSkipped = new Set(newSkipped.values());
      newSkipped.delete(activeStep);
    }

    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setSkipped(newSkipped);
  };
  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const isStepSkipped = (step) => {
    return skipped.has(step);
  };

  return (
    <>
      <div className="border-content">
        <Backdrop
          sx={{
            color: "#fff",
            zIndex: (theme) => theme.zIndex.drawer + 1,
          }}
          open={loading}
        >
          <CircularProgress
            sx={{
              animationDuration: "550ms",
            }}
            color="inherit"
          />
        </Backdrop>
        <div
          style={{
            flex: 1,
            flexDirection: "column",
            justifyContent: "start",
            width: "100%",
          }}
        >
          เลขประจำตัวประชาชน หรือ เลขที่หนังสือเดินทาง
        </div>
        <TextField
          InputProps={{ sx: { marginTop: 2, borderRadius: 16 } }}
          id="bank_account_name"
          type="search"
          placeholder="โปรดระบุ"
          variant="outlined"
          size="small"
          fullWidth
          value={citizenId}
          onChange={(e) => setCitizenId(e.target.value)}
        />
        {customerName && (
          <div
            style={{
              marginTop: 10,
              padding: 10,
              backgroundColor: "#f0f8ff",
              borderRadius: 8,
              fontSize: 14,
            }}
          >
            <strong>ชื่อ-นามสกุล:</strong> {customerName}
          </div>
        )}
      </div>
      <button
        style={{ marginTop: 10, fontSize: 15 }}
        onClick={verifyOtp}
        className="btn-checkout-premium w-100 p-2 bold"
      >
        ตกลง
      </button>
      <button
        className="btn-checkout-back w-100 p-2 bold"
        onClick={handleBack}
      >
        กลับ
      </button>
    </>
  );
};

export default EnterCitizenId;
